import React from 'react';
import { Document, Page, Text, View } from '@react-pdf/renderer';
import { PDFStyles } from '../ElectricalInstallationCertificate/styles/ElectricalInstallationCertificatePDF';
import { transformForPDF } from './transform';

const EICR_PDF = ({ formData }) => {
  const data = transformForPDF(formData);

  const assessmentColor = data.overallAssessment === 'SATISFACTORY'
    ? '#008855'   // Safety Green
    : '#CC0000';  // Danger Red

  return (
    <Document>
      <Page size="A4" style={PDFStyles.page}>
        {/* Header */}
        <View style={PDFStyles.headerPanel}>
          <Text style={PDFStyles.title}>{data.title}</Text>
          <Text style={PDFStyles.subtitle}>{data.standard}</Text>
          <Text style={PDFStyles.subtitle}>
            Report No: {data.reportDetails.reportNumber} | Date: {data.reportDetails.reportDate}
          </Text>
        </View>

        {/* Report Details */}
        <View style={PDFStyles.section}>
          <Text style={PDFStyles.sectionTitle}>Report Details</Text>
          <View style={PDFStyles.fieldRow}>
            <Text style={PDFStyles.fieldLabel}>Purpose:</Text>
            <Text style={PDFStyles.fieldValue}>{data.reportDetails.purposeOfReport}</Text>
          </View>
          <View style={PDFStyles.fieldRow}>
            <Text style={PDFStyles.fieldLabel}>Inspection Type:</Text>
            <Text style={PDFStyles.fieldValue}>{data.reportDetails.inspectionType}</Text>
          </View>
        </View>

        {/* Client */}
        <View style={PDFStyles.section}>
          <Text style={PDFStyles.sectionTitle}>Client / Customer</Text>
          <View style={PDFStyles.fieldRow}>
            <Text style={PDFStyles.fieldLabel}>Name:</Text>
            <Text style={PDFStyles.fieldValue}>{data.client.name}</Text>
          </View>
          <View style={PDFStyles.fieldRow}>
            <Text style={PDFStyles.fieldLabel}>Address:</Text>
            <Text style={PDFStyles.fieldValue}>{data.client.address}</Text>
          </View>
        </View>

        {/* Property */}
        <View style={PDFStyles.section}>
          <Text style={PDFStyles.sectionTitle}>Premises / Property</Text>
          <View style={PDFStyles.fieldRow}>
            <Text style={PDFStyles.fieldLabel}>Address:</Text>
            <Text style={PDFStyles.fieldValue}>{data.property.address}</Text>
          </View>
          <View style={PDFStyles.fieldRow}>
            <Text style={PDFStyles.fieldLabel}>Type:</Text>
            <Text style={PDFStyles.fieldValue}>{data.property.type}</Text>
          </View>
          <View style={PDFStyles.fieldRow}>
            <Text style={PDFStyles.fieldLabel}>Bedrooms / Floors:</Text>
            <Text style={PDFStyles.fieldValue}>{data.property.bedrooms}</Text>
          </View>
          <View style={PDFStyles.fieldRow}>
            <Text style={PDFStyles.fieldLabel}>Est. Age:</Text>
            <Text style={PDFStyles.fieldValue}>{data.property.age}</Text>
          </View>
        </View>

        {/* Installation Details */}
        <View style={PDFStyles.section}>
          <Text style={PDFStyles.sectionTitle}>Installation Details / Extent & Limitations</Text>
          <View style={PDFStyles.fieldRow}>
            <Text style={PDFStyles.fieldLabel}>Supply:</Text>
            <Text style={PDFStyles.fieldValue}>
              {data.installation.mainSupply} | {data.installation.earthingArrangement} | Ze: {data.installation.externalZe} Ω
            </Text>
          </View>
          <View style={PDFStyles.fieldRow}>
            <Text style={PDFStyles.fieldLabel}>Extent & Limitations:</Text>
            <Text style={PDFStyles.fieldValue}>{data.installation.extentLimitations}</Text>
          </View>
        </View>

        {/* Observations */}
        <View style={PDFStyles.section} wrap={false}>
          <Text style={PDFStyles.sectionTitle}>Observations</Text>
          {data.observations.length === 0 ? (
            <Text style={PDFStyles.fieldValue}>No observations recorded.</Text>
          ) : data.observations.map((o, i) => (
            <View key={i} style={PDFStyles.fieldRow}>
              <Text style={PDFStyles.fieldValue}>
                {o.code} - {o.location}: {o.details}
              </Text>
            </View>
          ))}
        </View>

        {/* Overall Assessment banner */}
        <View style={[PDFStyles.assessment, { borderColor: assessmentColor }]} wrap={false}>
          <Text style={[PDFStyles.assessmentTitle, { color: assessmentColor }]}>
            Overall Assessment: {data.overallAssessment}
          </Text>
          {data.forceReason && (
            <Text style={PDFStyles.standard}>{data.forceReason}</Text>
          )}
        </View>

        {/* Summary / Recommendations */}
        <View style={PDFStyles.section}>
          <Text style={PDFStyles.sectionTitle}>Summary & Recommendations</Text>
          <View style={PDFStyles.fieldRow}>
            <Text style={PDFStyles.fieldLabel}>Summary:</Text>
            <Text style={PDFStyles.fieldValue}>{data.recommendation.summaryCondition}</Text>
          </View>
          <View style={PDFStyles.fieldRow}>
            <Text style={PDFStyles.fieldLabel}>Recommendations:</Text>
            <Text style={PDFStyles.fieldValue}>{data.recommendation.recommendations}</Text>
          </View>
        </View>

        {/* Declaration & Signatures */}
        <View style={PDFStyles.section} wrap={false}>
          <Text style={PDFStyles.sectionTitle}>Declaration</Text>
          <Text style={PDFStyles.declaration}>
            I have inspected and tested the electrical installation to which this report
            relates and the result of inspection and testing, as recorded in this report,
            is {data.overallAssessment.toLowerCase()}.
          </Text>
          <View style={PDFStyles.signatureRow}>
            <View style={PDFStyles.signatureBox}>
              <Text>Engineer: {data.declaration.engineerName} (Card: {data.declaration.engineerCardNumber})</Text>
            </View>
            <View style={PDFStyles.signatureBox}>
              <Text>Client: {data.declaration.clientSignature}</Text>
            </View>
          </View>
        </View>

        {/* Footer */}
        <View style={PDFStyles.footer}>
          <Text>
            Report No: {data.reportDetails.reportNumber} | {data.standard} | Page
          </Text>
        </View>
      </Page>
    </Document>
  );
};

export default EICR_PDF;